// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"88c7296f","239":"e5d3ff98","455":"29fc9f35"}[chunkId] + ".chunk.js";
};